/*
 * authUtils.ts
 * Utilitaires d'authentification côté frontend.
 * Décodage du JWT stocké dans localStorage pour extraire les informations
 * de l'utilisateur courant sans appel réseau.
 */

import { jwtDecode } from 'jwt-decode';

// Structure minimale attendue dans le payload JWT Symfony
interface JwtPayload {
	exp: number;
	roles: string[];
	username?: string;
	email?: string;
}

/**
 * Extrait les rôles Symfony depuis le JWT stocké dans localStorage.
 * Retourne un tableau vide si le token est absent, invalide ou expiré.
 */
export function getCurrentUserRoles(): string[] {
	const token = localStorage.getItem('token');
	if (!token) return [];
	try {
		const decoded = jwtDecode<JwtPayload>(token);
		if (!decoded.exp || decoded.exp * 1000 <= Date.now()) return [];
		return decoded.roles ?? [];
	} catch {
		return [];
	}
}

/**
 * Retourne true si l'utilisateur courant possède le rôle ROLE_ADMIN.
 */
export function isCurrentUserAdmin(): boolean {
	return getCurrentUserRoles().includes('ROLE_ADMIN');
}
